import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { CustomerView } from '@/views/CustomerView';
import { AdminLogin } from '@/views/AdminLogin';
import { AdminDashboard } from '@/views/AdminDashboard';

function App() {
  const { session, loading } = useAuth();
  const [isAdminRoute, setIsAdminRoute] = useState(
    window.location.pathname.startsWith('/admin')
  );

  useEffect(() => {
    const onPop = () => setIsAdminRoute(window.location.pathname.startsWith('/admin'));
    onPop();
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const goToAdmin = () => {
    window.history.pushState({}, '', '/admin');
    setIsAdminRoute(true);
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-warm-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-warm-200 border-t-brand-500" />
      </div>
    );
  }

  if (isAdminRoute) {
    return session ? <AdminDashboard /> : <AdminLogin />;
  }

  return (
    <>
      <CustomerView />
      <button
        onClick={goToAdmin}
        className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-warm-900/90 px-4 py-2.5 text-sm font-medium text-white shadow-lg backdrop-blur transition-all hover:bg-warm-900 active:scale-95"
        title="Área administrativa"
        aria-label="Área administrativa"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span>Admin</span>
      </button>
    </>
  );
}

export default App;
